import { colors, fonts } from '@grupoboticario/flora-tokens/dist/casaMagalhaesNoite/web/ds'

export const casaMagalhaesNoite = {
  colors,
  fonts,
}
